<template>
  <div>
    <input
      :id="name"
      :name="name"
      v-model="input"
      type="text"
      @blur="focusOut"
      @focus="focusIn"
      :disabled="disabled"
      class="form-control text-right"
      :class="{
        'is-invalid': isError ? 1 : 0,
        'is-valid': isError === false && isValid,
      }"
      @change="$emit('change', $event.target.value)"
      v-on:keyup="$emit('keyup', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  name: 'InputFormatDecimal',
  components: {},
  props: {
    value: {
      type: [String, Number],
      default: () => {
        return this.input
      },
    },
    name: {
      type: String,
      default: () => {
        return ''
      },
    },
    isError: {
      type: Boolean,
      default: false,
    },
    isValid: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: () => {
        return false
      },
    },
  },
  mounted() {},
  data() {
    return {
      currencyValue: 0,
      input: '0.00',
    }
  },
  created: function() {
    if (this.value) {
      this.input = this.value
      this.focusOut()
    }
  },
  watch: {
    value: {
      handler(val) {
        this.input = val
        this.focusOut()
      },
      deep: true,
    },
  },
  methods: {
    focusOut() {
      this.currencyValue = parseFloat(this.input)
      if (isNaN(this.currencyValue)) {
        this.currencyValue = 0
      }
      this.input = this.currencyValue
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')

      this.$emit('input', this.currencyValue)
    },
    focusIn() {
      this.input = this.currencyValue.toString()
    },
  },
}
</script>
